/* Native Shopify URLs filter the entire collection, including later pages. */
(() => {
  document.querySelectorAll('[data-bbq-filters]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const base = new URL(root.dataset.base, location.origin);
    const here = new URL(location.href);
    const carry = ['preview_theme_id', '_ab', '_fd', '_sc'];
    const tags = here.pathname.slice(base.pathname.length).replace(/^\//, '').split('+').filter(Boolean).map(decodeURIComponent).map(t => t.replace(/^ef-bbq-install-/, 'bbq-install-'));
    const selects = [...root.querySelectorAll('[data-bbq-tag]')];
    selects.forEach(s => s.value = tags.find(t => [...s.options].some(o => o.value === t)) || '');
    const price = root.querySelector('[data-bbq-price]');
    const min = here.searchParams.get('filter.v.price.gte') || '';
    const max = here.searchParams.get('filter.v.price.lte') || '';
    if (min || max) {
      const v = (min || '0') + ':' + max;
      if (![...price.options].some(o => o.value === v)) price.add(new Option(`$${min || '0'}${max ? '–$' + max : ' & up'}`, v));
      price.value = v;
    }
    const selected = tags.length + Number(Boolean(min || max));
    root.querySelector('[data-bbq-active]').textContent = selected ? `${selected} active filter${selected === 1 ? '' : 's'}` : '';
    const clear = new URL(base);
    carry.forEach(k => { if (here.searchParams.has(k)) clear.searchParams.set(k, here.searchParams.get(k)); });
    root.querySelector('[data-bbq-clear]').href = clear.pathname + clear.search;
    form.addEventListener('submit', event => {
      event.preventDefault();
      const url = new URL(clear);
      // Keep category links (e.g. griddle installation) unless this form replaces that choice.
      const retained = tags.filter(t => !selects.some(s => t.startsWith(s.dataset.bbqTag)));
      const selectedTags = [...retained, ...selects.map(s => s.value).filter(Boolean)];
      if (selectedTags.length) url.pathname += '/' + selectedTags.map(encodeURIComponent).join('+');
      const [lo, hi] = price.value.split(':');
      if (lo) url.searchParams.set('filter.v.price.gte', lo);
      if (hi) url.searchParams.set('filter.v.price.lte', hi);
      url.searchParams.set('sort_by', root.querySelector('[data-bbq-sort]').value);
      location.assign(url.pathname + url.search);
    });
    // The legacy grid has its own AJAX state; BBQ uses complete URLs so paging/back
    // cannot drop a price or leave the controls describing an earlier result set.
    const grid = document.querySelector('[data-efxc], [data-ef-cv2]');
    grid?.addEventListener('click', event => {
      const page = event.target.closest('a[data-ef-page], a[data-efxc-page], .efxc-pagination a, .ef-cv2__pagination a');
      if (page && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
        event.stopImmediatePropagation();
      }
    }, true);
  });
})();
